import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-black p-8 font-sans">
      <Link to="/" className="text-blue-600 underline mb-8 inline-block">Back to Home</Link>

      <div className="max-w-3xl">
        <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
        <p className="mb-6"><strong>Effective Date:</strong> 01-01-2026</p>

        <p className="mb-6">Trukr (“Company,” “we,” “our,” or “us”) respects your privacy and is committed to protecting the personal information you provide to us. This Privacy Policy explains what information we collect, how we use it, and with whom we share it.</p>

        <h3 className="font-bold mt-6 mb-2">1. Information We Collect</h3>
        <p className="mb-4">We may collect the following personal information:</p>
        <ul className="list-disc pl-5 mb-4">
          <li>Name</li>
          <li>Phone number</li>
          <li>Email address</li>
          <li>Company name</li>
          <li>Billing or payment-related information</li>
          <li>Service-related information provided by customers</li>
          <li>Any other information you voluntarily submit through our website, forms, phone, SMS, or email communication</li>
        </ul>

        <h3 className="font-bold mt-6 mb-2">2. How We Use Personal Information</h3>
        <p className="mb-4">We use personal information to:</p>
        <ul className="list-disc pl-5 mb-4">
          <li>Provide consulting and support services</li>
          <li>Respond to inquiries and customer service requests</li>
          <li>Schedule appointments and follow up on service requests</li>
          <li>Send service updates, reminders, and account-related notifications</li>
          <li>Process payments and maintain business records</li>
          <li>Improve our services and customer experience</li>
          <li>Communicate with customers by phone, email, and SMS regarding requested services</li>
        </ul>

        <h3 className="font-bold mt-6 mb-2">3. Who We Share Personal Information With</h3>
        <p className="mb-4">We may share personal information with:</p>
        <ul className="list-disc pl-5 mb-4">
          <li>Employees and contractors who need the information to provide services</li>
          <li>Service providers who help operate our business, such as payment processors, CRM platforms, scheduling systems, and communication tools</li>
          <li>Government agencies or legal authorities when required by law</li>
        </ul>
        <p className="mb-4">We do not sell personal information to third parties.</p>
        <p className="font-bold mb-4 italic text-red-700">SMS consent is not shared with third parties or affiliates for marketing purposes.</p>

        <h3 className="font-bold mt-6 mb-2">4. SMS Communications</h3>
        <p className="mb-4">If you provide your phone number and consent to receive text messages, we may send you conversational or informational SMS messages related to your account, appointments, support requests, service updates, and business communications.</p>
        <p className="mb-4">Message and data rates may apply. Message frequency may vary. You may opt out at any time by replying <strong>STOP</strong>. For help, reply <strong>HELP</strong> or contact us at info@trukr.us or 708-960-2690.</p>

        <h3 className="font-bold mt-6 mb-2">5. Data Security</h3>
        <p className="mb-4">We take reasonable administrative, technical, and physical measures to protect your personal information from unauthorized access, use, or disclosure.</p>

        <h3 className="font-bold mt-6 mb-2">6. Your Choices</h3>
        <p className="mb-4">You may contact us at any time to request access to, update, correct, or delete your personal information, or to opt out of SMS communications.</p>

        <h3 className="font-bold mt-6 mb-2">7. Changes to This Privacy Policy</h3>
        <p className="mb-4">We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>

        <h3 className="font-bold mt-6 mb-2">8. Contact Us</h3>
        <p><strong>Trukr</strong></p>
        <p>info@trukr.us</p>
        <p>7089602690</p>
        <p>www.trukr.us</p>
      </div>
    </div>
  );
};

export default Privacy;